import WorldGrid from "../grid/WorldGrid";
import CharacterPhysics from "./CharacterPhysics";

export default class PhysicsManager {
    /**
     * @param {WorldGrid} worldGrid
     * @param {Projection} projection 
     * @param {GameTime} gameTime
     */
    constructor(worldGrid, projection, gameTime) {

        /**
         * @constant
         * @private
         * @type {CharacterPhysics}
         */
        this.characterPhysics = new CharacterPhysics(worldGrid, projection, gameTime);

        // /**
        //  * @constant
        //  * @private
        //  * @type {GridPhysics}
        //  */
        // this.gridPhysics = new GridPhysics(worldGrid);
    }

    /**
     * @param {number} frameTimeRatio 
     */
    updatePhysicsForFrame(frameTimeRatio) {

        ////////////////////////////////////////////
        // Grid Physics
        ////////////////////////////////////////////

        //this.gridPhysics.updatePhysicsForFrame(frameTimeRatio);

        ////////////////////////////////////////////
        // Character Physics
        ////////////////////////////////////////////

        this.characterPhysics.updatePhysicsForFrame(frameTimeRatio);
    }

}